module.exports = __webpack_public_path__ + "fonts/Roboto-Thin.8e1900ea.ttf";